import mapKnownValues from "@/utils/mapKnownValues";
import sortBy from "lodash/sortBy";

export type StationConfigEntry = {
  key: string;
  readonly: boolean;
  value: string;
};

export type StationConfigAPIResponse = {
  configuration: string;
  id: string;
  updatedAt: Date;
};

export default class StationConfig {
  items: StationConfigEntry[] = [];
  id = "";
  updatedAt = new Date();

  constructor(params: Partial<StationConfig> = {}) {
    mapKnownValues(this, params);
    this.items = sortBy(this.items, item => item.key);
  }

  static fromAPI(response: StationConfigAPIResponse) {
    return new StationConfig({
      items: JSON.parse(response.configuration).configurationKey,
      id: response.id,
      updatedAt: new Date(response.updatedAt)
    });
  }
}
